import { VETRO_API_DOMAIN, VETRO_API_TOKEN } from "./constants";

export default abstract class VetroService {

    private static getHeaders(): {[key: string]: string} {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': VETRO_API_TOKEN || 'API_KEY',
        }
    }


    public static async getVetroAddressMatches(addressQuery: string): Promise<any> {
        // Parse the JSON to extract the query/filter string
        const queryObj = JSON.parse(addressQuery);
        const filterString = queryObj.query || queryObj.filter;

        const params = new URLSearchParams({
            filter: filterString,
            limit: '25'
        });

        const resp = await fetch(`${VETRO_API_DOMAIN}/features/query?${params.toString()}`, {
            method: 'GET',
            headers: this.getHeaders(),
        });

        const result = await resp.json();
        return result;
    }


    public static async updateVetroFeature(featureQuery: string): Promise<any[]> {
        const resp = await fetch(`${VETRO_API_DOMAIN}/features`,
        {
            method: 'PATCH',
            headers: this.getHeaders(),
            body: featureQuery,
        });

        const result = await resp.json();
        return result;
    }
}